import { render } from "./SignupForm.vue?vue&type=template&id=69e63e31&lang=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__